import { Component, OnInit } from '@angular/core';
import { CompanyApiService } from 'src/app/services/api/companies.api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserApiService } from 'src/app/services/api/user.api.service';
import { Location } from '@angular/common';
import { Company } from '../../classes/Company.class';
import { countries } from '../../../assets/data/countries';
import { User } from 'src/app/classes/User.class';
import { Country } from 'src/app/classes/Country.class';
import { arrSuperUsers } from 'src/app/services/utility-functions';

@Component({
  selector: 'company-detail-screen',
  templateUrl: './company-detail.screen.html',
  styleUrls: ['./company-detail.screen.scss'],
})
export class CompanyDetailScreenComponent implements OnInit {
  company: Company;
  companyUsers: User[];
  superUserId: number;
  oldSuperUserId: number;
  countries: Country[];
  user: User;
  errorCompany = false;
  companySaved = false;
  modalText: string;
  countSuperUser: boolean;
  fileUploadError = false;
  uploadedFileName: string;

  constructor(
    private companyApiService: CompanyApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userApiService: UserApiService,
    private _location: Location,
  ) {}

  async ngOnInit() {
    this.countries = countries;
    this.user = await this.userApiService.getAdmin();
    await this.activatedRoute.params.subscribe(async params => {
      const companyId = params.companyId;
      this.newCompany();
      if (companyId === null || companyId == 'null') {
        this.newCompany();
      } else {
        this.company = await this.companyApiService.getCompany(companyId);
        this.companyUsers = await this.userApiService.getUsersForCompany(companyId);
        this.countSuperUser = this.checkForSuperUser(this.companyUsers);
        for (let i = 0; i < this.companyUsers.length; i++) {
          if (this.companyUsers[i].role == 'super_admin') {
            this.superUserId = this.companyUsers[i].id;
            this.oldSuperUserId = this.companyUsers[i].id;
          }
        }
      }
    });
  }

  async onLogoFileChange(event: any) {
    const fileReader: FileReader = new FileReader();
    const file: File = event.target.files[0];
    const maxSizeInBytes = 1 * 1024 * 1024;

    if (file.size > maxSizeInBytes) {
      this.fileUploadError = true;
      return;
    }
    this.fileUploadError = false;
    this.uploadedFileName = file.name;

    fileReader.onloadend = e => {
      this.company.logo = fileReader.result as string;
    };
    fileReader.readAsDataURL(file);
  }

  private newCompany() {
    this.company = {
      name: '',
      active: 0,
    };
  }

  async updateSuperUser() {
    await this.userApiService.updateUserRole(this.oldSuperUserId, 'admin');
    await this.userApiService.updateUserRole(this.superUserId, 'super_admin');
  }

  async saveCompany() {
    if (this.superUserId !== this.oldSuperUserId) this.updateSuperUser();

    if (Object.keys(this.company).length > 1 && this.company.name !== '') {
      const response = await this.companyApiService.saveCompany(this.company);
      if (!response.code) {
        this.setModalText('response.save_company');
        this.companySaved = true;
        setTimeout(() => {
          this.companySaved = false;
          this.router.navigateByUrl('/companies');
        }, 2700);
      } else {
        this.errorCompany = true;
      }
    }
  }

  /**
   * chek if user has more than one super user
   */
  checkForSuperUser(users: User[]): boolean {
    const arr: User[] = arrSuperUsers(users);
    return arr.length > 1 ? true : false;
  }

  goToSummary(companyId) {
    this.router.navigateByUrl(`/companies/${companyId}`);
    return true;
  }

  goBack() {
    this._location.back();
  }

  goToCompanyList() {
    this.router.navigateByUrl('/companies');
  }

  closeModal() {
    this.companySaved = false;
  }

  setModalText(val: string) {
    this.modalText = val;
  }

  get mowaAdmin() {
    return this.user.role === 'mowa_admin';
  }

  get admin() {
    return this.user.role === 'admin';
  }

  get adminOrsuperAdmin() {
    return this.user.role === 'super_admin' || this.user.role === 'admin';
  }
}
